export const STEPS_KEYS = {
  1: 'refForFirstStep',
  2: 'refForSecondStep',
  3: 'refForThirdStep',
  4: 'refForFourthStep'
}
